import React from "react";
import { withRouter } from "react-router-dom";
import Entity from "../components/Entity";
import Header from "./Header";

const HeaderContainer = ({ location }) => {
  if (
    /\/course\/[0-9a-fA-F]{24}\/modules\/[0-9a-fA-F]{24}\/units\/[0-9a-fA-F]{24}\/exercise/.test(location.pathname) ||
    /\/course\/[0-9a-fA-F]{24}\/homeworks\/[0-9a-fA-F]{24}\/modules\/[0-9a-fA-F]{24}\/units\/[0-9a-fA-F]{24}\/exercise/.test(
      location.pathname
    ) ||
    /^\/course\/[0-9a-fA-F]{24}\/modules\/[0-9a-fA-F]{24}\/mastery-test\/[0-9a-fA-F]{24}\/execution$/.test(
      location.pathname
    ) ||
    /\/course\/[0-9a-fA-F]{24}\/certification-test\/[0-9a-fA-F]{24}\/abilities/.test(location.pathname) ||
    /\/course\/[0-9a-fA-F]{24}\/certification-test\/[0-9a-fA-F]{24}\/abilities\/[A-Z]\/execution/.test(
      location.pathname
    ) ||
    /\/course\/[0-9a-fA-F]{24}\/bonus-test\/execution/.test(location.pathname) ||
    /\/rankings\/[0-9]{6}\/closed/.test(location.pathname)
  ) {
    return null;
  }

  return (
    <Entity name="profile">
      {({ getById: getProfileById }) => (
        <Entity name="company">
          {({ getById: getCompanyById }) => {
            const profile = getProfileById(sessionStorage.getItem("id"));
            const company = getCompanyById(profile.company);

            return <Header logoSrc={company.logoUrl} />;
          }}
        </Entity>
      )}
    </Entity>
  );
};

export default withRouter(HeaderContainer);
